import type React from 'react';

import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import Tooltip from '@components/Presentation/atoms/Tooltip';

import { useRoSContext } from '@components/Presentation/context/RoSContext';
import { Dropdown, DropdownItem, DropdownMenu, DropdownTrigger } from '@atoms/new/dropdown';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import Button from '@atoms/new/button';
import { fontList } from '@atoms/fontList';

interface RoSFontFamilyProps {
  children: React.ReactNode;
  tooltip?: string;
}
function RoSTextFont({ children, tooltip }: RoSFontFamilyProps) {
  const { selectedSlide } = useRoSContext();
  const fonts = fontList;

  return (
    <div className='flex items-center justify-between'>
      <h4 className={'text-sm flex gap-2 '}>
        {children}
        {tooltip && (
          <Tooltip content={tooltip}>
            <HelpRoundedIcon
              fontSize="small"
              color="disabled"
              className='dark:text-grey-400'
            />
          </Tooltip>
        )}
      </h4>

      <Dropdown
        placement='bottom-start'
      >
        <DropdownTrigger>
          <Button
            kind='tertiary'
            size='sm'
            className='w-[140px] '
            endContent={<KeyboardArrowDownRoundedIcon fontSize='small'/>}
          >
            <p className='w-full text-start font-normal'>{selectedSlide.setting.FontStyle}</p>

          </Button>
        </DropdownTrigger>
        <DropdownMenu className='max-h-[40vh] overflow-scroll'
          disallowEmptySelection
          selectedKeys={[selectedSlide.setting.FontStyle || 'Sans-Serif']}
          selectionMode="single"
          variant="flat"
        >
          {fonts.map((option) => (
            <DropdownItem
              key={option}
              value={option}
              onClick={() =>
                selectedSlide.handler.updateSetting('FontStyle', option)
              }
              style={{ fontFamily: option }}
            >
              {option}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}

export default RoSTextFont;
